import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { LicenseInfoDto, SoftwareInfoDto } from 'UvExplorerServer.Dtos.TS/LicenseStats';
import { LicensingService } from '../../services/licensing.service';

@Component({
    selector: 'license-manager',
	templateUrl: './license-manager.component.html',
	styleUrls: ['./license-manager.component.scss']
})
export class LicenseManagerComponent implements OnDestroy {

	public hasLocalLicense: boolean;
	public productVersion: string;
	public softwareVersion: string;
	public licenseStatusMessage: string;
	public licensedTo: string;
	public encodedProductKey: string;
	public licenseLimitStr: string;
	public licenseCountStr: string;
	public activationWizardVisible: boolean;
	public deactivationWizardVisible: boolean;
	public updateWizardVisible: boolean;
	public swUpdateMessage: string;
	public swUpdateIsNew: boolean;
	public swUpdateInstallerUrl: string;
	public swUpdateSetupUrl: string;
	public swUpdateIsClientLocal: boolean;
	public enableCheckForSwUpdate: boolean;

	constructor(private licensingService: LicensingService) {
		this.hasLocalLicense = false;
		this.productVersion = "";
		this.softwareVersion = "";
		this.licenseStatusMessage = "";
		this.licensedTo = "";
		this.encodedProductKey = "";
		this.licenseLimitStr = "";
		this.licenseCountStr = "";
		this.activationWizardVisible = false;
		this.deactivationWizardVisible = false;
		this.updateWizardVisible = false;
		this.swUpdateMessage = "The latest version is already installed.";
		this.swUpdateIsNew = false;
		this.swUpdateInstallerUrl = "";
		this.swUpdateSetupUrl = "";
		this.swUpdateIsClientLocal = false;
		this.enableCheckForSwUpdate = false;

		this.updateLicenseInfo();
		this.updateSoftwareUpdateInfo();
	}

	public ngOnDestroy(): void {
	}

	private updateLicenseInfo(): void {
		this.licensingService.getLicenseInfo().subscribe(
			(result: LicenseInfoDto) => {
				this.hasLocalLicense = result.hasLocalLicense;
				this.productVersion = result.productVersion;
				this.softwareVersion = "Build " + result.buildNumber + " (" + result.buildTime + ")";
				this.licenseStatusMessage = result.licenseStatusMessage;
				this.licensedTo = result.licensedTo;
				this.encodedProductKey = result.encodedProductKey;
				this.licenseLimitStr = ((result.licenseLimit >= 0) ? result.licenseLimit.toString() : "");
				this.licenseCountStr = ((result.licenseCount >= 0) ? result.licenseCount.toString() : "");
			},
			(error) => {
				console.error("Error while getting license info");
			});
	}

	private updateSoftwareUpdateInfo(): void {
		this.enableCheckForSwUpdate = false;

		this.licensingService.getSoftwareUpdateInfo().subscribe(
			(result: SoftwareInfoDto) => {
				this.enableCheckForSwUpdate = true;

				this.swUpdateIsNew = result.isNewVersion;
				this.swUpdateInstallerUrl = result.installerUrl;
				this.swUpdateSetupUrl = result.setupUrl;
				this.swUpdateIsClientLocal = result.isClientLocal;

				if (result.isNewVersion) {
					this.swUpdateMessage = `A new version is available: Version ${result.productVersion} Build ${result.buildNumber} ${result.buildTime}`;
				}
				else {
					this.swUpdateMessage = "The latest version is already installed."
				}
			},
			(error) => {
				this.enableCheckForSwUpdate = true;
				console.error("Error while getting software update info");
			});
	}

	public checkForSoftwareUpdate(): void {
		this.updateSoftwareUpdateInfo();
	}

	public onLicenseChange(): void {
		this.updateLicenseInfo();
	}

	public activateLicense(): void {
		this.activationWizardVisible = true;
	}

	public updateLicense(): void {
		this.updateWizardVisible = true;
	}

	public deactivateLicense(): void {
		this.deactivationWizardVisible = true;
	}

}